import component from './NumberBadge'

export default component
